import { EmpreintesCarboneData } from '@services/interfaces/generated/YSER-v1';
import { emptyGuid } from '@shared/constants';
import APIServicesBase from './APIServicesBase';
import { EmpreintesCarboneSearchFilters } from './types';
import { setQueryParamsWithoutPagination } from './utils';

export default class EmpreintesCarboneAPIService extends APIServicesBase {
  obtenirEmpreintesCarboneEquipements(
    href?: string,
    options?: EmpreintesCarboneSearchFilters,
  ): Promise<EmpreintesCarboneData | undefined> {
    if (href === undefined || href === emptyGuid) {
      return Promise.resolve(undefined);
    }

    const url = this.getUrl(href);
    setQueryParamsWithoutPagination(url, options);

    return this.bquery.get<EmpreintesCarboneData>(url.toString());
  }
}
